/* GENERATED by build_from_tokens.py. Do not hand-edit.
   Horizon sizes every carousel slide to the tallest media; this sets the frame's height to the active slide's own ratio
   (read from --media-preview-ratio) so a landscape shot after a portrait one isn't letterboxed. Layout of the slides is
   untouched, so Horizon's visibility observer stays stable. */
(function () {
  function fit(gallery) {
    var c = gallery.querySelector('slideshow-container');
    var a = gallery.querySelector('slideshow-slide[aria-hidden="false"]');
    if (!c || !a) return;
    var img = a.querySelector('img');
    var r = parseFloat(getComputedStyle(a).getPropertyValue('--media-preview-ratio'));
    if (!(r > 0) && img) {
      var w = img.naturalWidth || parseFloat(img.getAttribute('width')), h = img.naturalHeight || parseFloat(img.getAttribute('height'));
      if (w > 0 && h > 0) r = w / h;
      if (!img.complete) img.addEventListener('load', function () { fit(gallery); }, { once: true });
    }
    if (r > 0 && c.clientWidth > 0) c.style.height = Math.round(c.clientWidth / r) + 'px';
  }
  function watch(gallery) {
    if (gallery.dataset.jvFit) return;
    gallery.dataset.jvFit = '1';
    var t;
    var run = function () { clearTimeout(t); t = setTimeout(function () { fit(gallery); }, 60); };
    new MutationObserver(run).observe(gallery, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] });
    window.addEventListener('resize', run);
    fit(gallery);
  }
  function noDrag(gallery) {
    // Horizon starts a drag on pointerdown at the slideshow component; stop it at the track. Clicks (zoom) still fire.
    // Horizon's drag starts on a 'mousedown' listener on the track (slideshow-slides); stop it in the capture phase
    // on the gallery so it never reaches the track. Clicks (zoom) still fire; touch swipe is already off (overflow hidden).
    // (disabled="true" on the component would also block the thumbnails' select() — don't.)
    gallery.addEventListener('mousedown', function (e) {
      if (e.target.closest && e.target.closest('slideshow-slides')) e.stopPropagation();
    }, true);
  }
  function zoomOrigin(gallery) {
    gallery.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var slide = e.target.closest('slideshow-slide');
      var img = slide && slide.querySelector('img');
      if (!img) return;
      var r = slide.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    });
  }
  function scan() { document.querySelectorAll('.product-information__media media-gallery').forEach(function (g) { var first = !g.dataset.jvFit; watch(g); if (first) { noDrag(g); } }); }
  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });

  // No hamburger: Horizon sets data-menu-style=drawer on touch devices at every width (utilities.js) and re-evaluates on
  // resize / overflow; pin it to 'menu' (the CSS also hides the drawer toggle, this keeps the desktop layout rules in force).
  (function () {
    var h = document.getElementById('header-component');
    if (!h) return;
    var pin = function () {
      if (h.dataset.menuStyle !== 'menu') h.dataset.menuStyle = 'menu';
      // Never fold links into "More": disabled makes <overflow-list> put every item back in the row (the row wraps instead, like Webflow)
      // Horizon's first reflow runs on a timer after load (and re-attaches its observers), so re-assert whenever an item lands in the
      // overflow slot: setting disabled runs its reset (all items back, observers off). Its own reflow can't loop after that.
      var ol = h.querySelector('overflow-list');
      if (!ol) return;
      var folded = ol.querySelector(':scope > [slot="overflow"]');
      if (ol.getAttribute('disabled') !== 'true' || folded) ol.setAttribute('disabled', 'true');
      if (ol.hasAttribute('minimum-reached')) ol.removeAttribute('minimum-reached');
    };
    pin();
    new MutationObserver(pin).observe(h, { attributes: true, subtree: true, attributeFilter: ['data-menu-style', 'disabled', 'slot', 'minimum-reached'] });
  })();

  // Footer newsletter: post the address to Substack's no-JavaScript signup endpoint in the background and confirm on the page.
  // Substack sends no CORS headers, so the reply can't be read (mode: no-cors); the success line is optimistic. A network failure
  // offers Substack's own page with the address pre-filled. Without JavaScript the form's action/target open that page instead.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.jv-newsletter');
    if (!form || !window.fetch || !form.dataset.endpoint) return;
    e.preventDefault();
    var input = form.querySelector('input[type=email]'), note = form.querySelector('.jv-newsletter__note'), btn = form.querySelector('button');
    var email = (input && input.value || '').trim();
    if (!email) return;
    var body = new URLSearchParams({ email: email, source: 'embed', first_url: location.href, first_referrer: document.referrer,
                                     current_url: location.href, current_referrer: document.referrer });
    if (btn) btn.disabled = true;
    fetch(form.dataset.endpoint, { method: 'POST', mode: 'no-cors', body: body, credentials: 'omit' }).then(function () {
      if (note) note.textContent = form.dataset.success || '';
      input.value = '';
    }).catch(function () {
      if (note) {
        note.textContent = (form.dataset.fallback || '') + ' ';
        var a = document.createElement('a');
        a.href = form.action + '?email=' + encodeURIComponent(email); a.target = '_blank'; a.rel = 'noopener';
        a.textContent = form.dataset.fallbackLink || 'Subscribe on Substack';
        note.appendChild(a);
      }
    }).then(function () { if (btn) btn.disabled = false; });
  });

  // Sold-out notify form: submit in place and confirm on the page (Shopify's redirect after a customer form drops the variant
  // and the ?customer_posted flag when return_to has a query, so the server-side message never showed). A captcha challenge
  // falls back to a real navigation.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.jv-reprint__form');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var wrap = form.closest('.jv-reprint'), details = form.querySelector('.jv-reprint__details'), btn = form.querySelector('.jv-reprint__submit');
    var say = function (cls, text) { var p = document.createElement('p'); p.className = cls; p.textContent = text; return p; };
    if (btn) btn.disabled = true;
    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', redirect: 'follow' }).then(function (res) {
      if (/\/challenge/.test(res.url)) { form.submit(); return; }
      if (res.ok && /customer_posted=true/.test(res.url)) { form.replaceChildren(say('jv-reprint__success', wrap.dataset.success)); return; }
      throw new Error('not posted');
    }).catch(function () {
      if (btn) btn.disabled = false;
      var old = form.querySelector('.jv-reprint__error'); if (old) old.remove();
      (details ? details.querySelector('.jv-reprint__fields') : form).appendChild(say('jv-reprint__error', wrap.dataset.error));
    });
  });

  // Sold-out notify block (.jv-reprint, a custom-liquid block): Horizon re-fetches the section on variant change but only
  // morphs its own blocks, so swap ours from the fetched document once the product-select promise resolves.
  document.addEventListener('shopify:product:select', function (e) {
    if (!e.promise) return;
    e.promise.then(function (res) {
      var html = res && res.detail && res.detail.html;
      ['.jv-reprint', '.jv-stock'].forEach(function (sel) {   // custom-liquid blocks keep their first render; swap them in
        var next = html && html.querySelector('.product-details ' + sel);
        var cur = document.querySelector('.product-details ' + sel);
        if (next && cur) cur.replaceWith(document.importNode(next, true));
      });
    }).catch(function () {});
  });
})();
